/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useDispatch, useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import { RoutePath } from 'shared/enums/RoutePath';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { ThunkStatus } from '../../../enums/ThunkStatus';
import { selectDialog, selectStatus, selectUserId, toggleRemoveUserDialog } from './user.removeFromOrg.slice';
import { removeUserFromOrg } from './user.remove.thunk';

export default function useRemoveUserFromOrg(orgId, resetUsers) {
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();

  const dispatch = useDispatch();

  const status = useSelector(selectStatus);
  const removeDialog = useSelector(selectDialog);
  const userId = useSelector(selectUserId);

  const onToggleRemoveDialog = open => dispatch(toggleRemoveUserDialog(open));
  const updateUserId = newUserId => dispatch(updateUserId(newUserId));

  useEffect(() => {
    if (status === ThunkStatus.SUCCEEDED) {
      resetUsers();
    }

    setIsLoading(status === ThunkStatus.LOADING);
  }, [status]);

  const onRemoveUserConfirm = () => {
    dispatch(removeUserFromOrg({ userId, orgId }));
  };

  const onRemoveUserConfirmInOrg = () => {
    dispatch(removeUserFromOrg({ userId, orgId }));
    history.push(
      RoutePath.generateRoutePath(RoutePath.USER_SEARCH, {
        organization: orgId,
      }),
    );
  };

  return {
    isLoading,
    removeDialog,
    userId,
    updateUserId,
    onRemoveUserConfirm,
    onToggleRemoveDialog,
    onRemoveUserConfirmInOrg,
  };
}
